export enum UserRole {
    Admin = "A",
    Manager = "M",
    Staff = "SP",
}
